export default function CalenderCheckIcon({
  width = 14,
  height = 14,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00004 0.666687V2.00002H9.00004V0.666687H10.3334V2.00002H13C13.3682 2.00002 13.6667 2.2985 13.6667 2.66669V13.3334C13.6667 13.7016 13.3682 14 13 14H1.00004C0.631854 14 0.333374 13.7016 0.333374 13.3334V2.66669C0.333374 2.2985 0.631854 2.00002 1.00004 2.00002H3.66671V0.666687H5.00004ZM12.3334 5.33335H1.66671V12.6667H12.3334V5.33335ZM9.02371 6.75735L9.96651 7.70022L6.66671 11L4.30969 8.64302L5.25249 7.70022L6.66671 9.11442L9.02371 6.75735Z"
        fill={color}
      />
    </svg>
  );
}
